/* eslint-disable @typescript-eslint/no-var-requires */
export const propertyBarQuery = require('./property-bar.graphql');
export const propertyBarAuthQuery = require('./property-bar-auth.graphql');
export const updateSaveProperties = require('./update-save-properties.graphql');
